import React from 'react';

type BannerIconGlyphProps = {
  src?: string;
  className?: string;
  title?: string;
};

export default function BannerIconGlyph({ src, className, title }: BannerIconGlyphProps) {
  if (!src) return null;
  return (
    <span
      aria-hidden={title ? undefined : true}
      className={['banner-icon-glyph', className].filter(Boolean).join(' ')}
      role={title ? 'img' : undefined}
      style={{
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
      }}
      title={title}
    />
  );
}
